import { getCurrentInstance } from 'vue';
import router from '@/router'; // Importujte přímo instanci routeru
export default {
    beforeMount(el, binding, vnode) {
        const $t = binding.value.$t

        let displayCount = binding.value.limit;
        const displayComplete = binding.value.values.length;
        let arr = binding.value.values.slice(0, displayCount)

        const openLink = (path) => {
            try {
                router.push(path);
                if (router) {

                }
            }catch (e) {
                console.log('dev openLink ERR', e)
            }
        }

        const render = () => {
            const historyListWrap = document.createElement('div');
            historyListWrap.classList.add('card')
            historyListWrap.classList.add('widget-card')
            historyListWrap.classList.add('bsb-timeline-8')
            historyListWrap.classList.add('border-light')
            historyListWrap.classList.add('shadow-sm-group')

            const historyListWrapInner = document.createElement('div');
            historyListWrapInner.classList.add('card-body')
            historyListWrapInner.classList.add('p-4')

            const historyListWrapList = document.createElement('ul');
            historyListWrapList.classList.add('timeline')
            for(const i in arr) {
                const listItem = document.createElement('li');
                listItem.classList.add('timeline-item')

                const listTimelineBody = document.createElement('div');
                listTimelineBody.classList.add('timeline-body')

                const listTimelineMeta = document.createElement('div');
                listTimelineMeta.classList.add('timeline-meta')

                const listTimelineDate = document.createElement('div');
                listTimelineDate.classList.add('date')

                //date
                /**/
                const dt = new Date(arr[i].dt);
                const dateFormated = new Intl.DateTimeFormat(
                    'cs-CZ',
                    {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    }
                );

                const formattedTime = new Intl.DateTimeFormat('cs-CZ', {
                    hour: '2-digit',
                    minute: '2-digit'
                });

                listTimelineDate.innerHTML = dateFormated.format(dt) + '<br/><small class="d-block text-muted __text-end">' + formattedTime.format(dt) + '</small>';
                listTimelineMeta.appendChild(listTimelineDate);

                const listTimelineContent = document.createElement('div');
                listTimelineContent.classList.add('timeline-content')
                listTimelineContent.classList.add('timeline-indicator')

                for(const v in arr[i].data) {
                    const valueWrap = document.createElement('div');
                    valueWrap.classList.add("text-secondary")
                    valueWrap.classList.add("fs-7")
                    valueWrap.classList.add("d-block")

                    //nazev

                    if ( typeof arr[i].data[v].value === 'string' ) {
                        if (arr[i].data[v].ico) {
                            const valueContentIco = document.createElement('i');
                            valueContentIco.className = arr[i].data[v].ico + ' me-2';
                            valueWrap.appendChild(valueContentIco);
                        }
                        if(arr[i].data[v].type.title) {
                            const valueContentType = document.createElement('span');
                            valueContentType.innerHTML = arr[i].data[v].type.title + ":";
                            valueContentType.classList.add("text-muted")
                            valueContentType.classList.add("me-2")
                            valueWrap.appendChild(valueContentType)
                        }



                        const valueContentValue = document.createElement('span');
                        valueContentValue.innerHTML = arr[i].data[v].value;
                        valueWrap.appendChild(valueContentValue)

                    } else if ( typeof arr[i].data[v].value === 'bool' ) {
                        if(arr[i].data[v].type.title) {
                            const valueContentType = document.createElement('span');
                            valueContentType.innerHTML = arr[i].data[v].type.title + ":";
                            valueContentType.classList.add("text-muted")
                            valueContentType.classList.add("me-2")
                            valueWrap.appendChild(valueContentType)
                        }

                    } else if ( typeof arr[i].data[v].value === 'object' ) {
                        if(
                            typeof arr[i].data[v].value.from != 'undefined'
                            && typeof arr[i].data[v].value.to != 'undefined'
                        ) {

                            if(arr[i].data[v].ico) {
                                const valueContentIco = document.createElement('i');
                                valueContentIco.className = arr[i].data[v].ico + ' me-2';
                                valueWrap.appendChild(valueContentIco);
                            }
                            if(arr[i].data[v].type.title) {
                                const valueContentType = document.createElement('span');
                                valueContentType.innerHTML = arr[i].data[v].type.title + ": ";
                                valueContentType.classList.add("text-muted")
                                valueContentType.classList.add("me-2")
                                valueWrap.appendChild(valueContentType)
                            }
                            const pairWrap = document.createElement('div');
                            pairWrap.classList.add("d-inline-block")
                            const fromWrap = document.createElement('span');
                            fromWrap.classList.add("text-decoration-line-through")
                            fromWrap.textContent = arr[i].data[v].value.from

                            const icoWrap = document.createElement('i');
                            icoWrap.classList.add("bi")
                            icoWrap.classList.add("bi-arrow-right-short")
                            icoWrap.classList.add("mx-2")

                            const toWrap = document.createElement('span');
                            toWrap.classList.add("fw-semibold")
                            toWrap.textContent = arr[i].data[v].value.to;

                            pairWrap.appendChild(fromWrap)
                            pairWrap.appendChild(icoWrap)
                            pairWrap.appendChild(toWrap)

                            valueWrap.appendChild(pairWrap)
                        }
                        else if (
                            typeof arr[i].data[v].value.display_type != 'undefined'
                            && arr[i].data[v].value.display_type == 'profile'
                        ) {

                            if(arr[i].data[v].ico) {
                                const valueContentIco = document.createElement('i');
                                valueContentIco.className = arr[i].data[v].ico + ' me-2';
                                valueWrap.appendChild(valueContentIco);
                            }

                            if( arr[i].data[v].type.title) {
                                const valueContentType = document.createElement('span');
                                valueContentType.innerHTML = arr[i].data[v].type.title + ": ";
                                valueContentType.classList.add("text-muted")
                                valueContentType.classList.add("me-2")
                                valueWrap.appendChild(valueContentType)
                            }

                            const profileWrap = document.createElement('div');
                            profileWrap.classList.add("row")
                            //profileWrap.classList.add("ms-3")

                            const profileImage = document.createElement('div');
                            profileImage.classList.add("col")
                            profileImage.classList.add("col-3")
                            profileImage.innerHTML = '[image]';

                            const profileData = document.createElement('div');
                            profileData.classList.add("col")
                            profileData.classList.add("col-auto")
                            profileData.innerHTML =  arr[i].data[v].value.name  + ' (' + arr[i].data[v].value.login + ')';

                            //profileWrap.appendChild(profileImage)
                            profileWrap.appendChild(profileData)

                            if(
                                arr[i].data[v].value.link
                            ){
                                profileWrap.classList.add("pseudo-link")
                                profileWrap.addEventListener('click', (e) => {
                                    e.preventDefault();
                                    openLink(arr[i].data[v].value.link)
                                })
                            }
                            valueWrap.classList.add("d-flex")
                            valueWrap.appendChild(profileWrap)
                        }
                        else {
                            console.log('dev directive display-history-v2 VLUE UNDEFNECT OBJECT ', typeof arr[i].data[v])
                            const valueContentType = document.createElement('span');
                            valueContentType.innerHTML = arr[i].data[v].type.title + ":";
                            valueContentType.classList.add("text-muted")
                            valueContentType.classList.add("me-2")
                            valueWrap.appendChild(valueContentType)


                            const valueContentValue = document.createElement('span');
                            valueContentValue.innerHTML = arr[i].data[v].value;
                            valueWrap.appendChild(valueContentValue)


                        }
                    }else{
                        console.log('dev directive display-history-v2 VLUE UNDEFNECT OBJECT #2 ', typeof arr[i].data[v], arr[i].data[v])

                        if (arr[i].data[v].ico) {
                            const valueContentIco = document.createElement('i');
                            valueContentIco.className = arr[i].data[v].ico + ' me-2';
                            valueWrap.appendChild(valueContentIco);
                        }


                        const valueContentType = document.createElement('span');
                        valueContentType.innerHTML = arr[i].data[v].type.title + ":";
                        valueContentType.classList.add("text-muted")
                        valueContentType.classList.add("me-2")
                        valueWrap.appendChild(valueContentType)


                        const valueContentValue = document.createElement('span');
                        if(arr[i].data[v].value === true) {
                            valueContentValue.innerHTML = '<i class="bi bi-check-circle-fill text-success"></i>';
                        } else if(arr[i].data[v].value === false){
                            valueContentValue.innerHTML = '<i class="bi bi-x-circle-fill text-danger"></i>';
                        }else{
                            valueContentValue.innerHTML = arr[i].data[v].value;
                        }

                        valueWrap.appendChild(valueContentValue)
                    }

                    listTimelineContent.appendChild(valueWrap);
                }

                listTimelineBody.appendChild(listTimelineMeta);
                listTimelineBody.appendChild(listTimelineContent);

                listItem.appendChild(listTimelineBody)
                historyListWrapList.appendChild(listItem)
            }

            historyListWrapInner.appendChild(historyListWrapList)
            historyListWrap.appendChild(historyListWrapInner)

            el.appendChild(historyListWrap);

            if(arr.length < binding.value.values.length) {
                const btnWrap = document.createElement('div');
                btnWrap.classList.add("text-center")
                btnWrap.classList.add("p-3")

                const btn = document.createElement('div');
                btn.classList.add("btn")
                btn.classList.add("btn-sm")
                btn.classList.add("btn-outline-primary")
                //valueWrap.classList.add("d-block")
                btn.textContent = $t('history.btn.load.title') + ' (' + arr.length + '/' + binding.value.values.length + ')'

                const icoBtn = document.createElement('i');
                icoBtn.classList.add("bi")
                icoBtn.classList.add("bi-search")
                icoBtn.classList.add("me-2")

                btn.prepend(icoBtn);

                btn.addEventListener('click', () => {
                    //console.log('dev load next')
                    //displayAll();
                    displayNextPage();
                })

                btnWrap.appendChild(btn);
                el.appendChild(btnWrap);
            }
        }

        const displayAll = () => {
            arr = binding.value.values;
            el.innerHTML = '';
            //console.log('dev displayAll', arr.length, displayComplete, displayCount)
            render();
        };

        const displayNextPage = () => {
            displayCount = displayCount + binding.value.limit;
            arr = binding.value.values.slice(0, displayCount)
            el.innerHTML = '';
            render();
        };

        render();

        const css = document.createElement('style');
        css.innerHTML = `
       
.fs-7 {
  font-size: .875rem !important
}

.bsb-timeline-8 {
  --bsb-tl-color: var(--bs-secondary-bg-subtle);
  --bsb-tl-circle-color: var(--bs-light);
  --bsb-tl-circle-border-color: var(--bs-secondary);
  --bsb-tl-indicator-color: var(--bs-white);
  --bsb-tl-circle-size: 16px;
  --bsb-tl-circle-offset: 8px;
  --bsb-tl-circle-border-size: 1px
}

.bsb-timeline-8 .timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline:after {
  background-color: var(--bsb-tl-color);
  bottom: 0;
  content: "";
  left: 0;
  margin-left: -1px;
  position: absolute;
  top: 0;
  width: 2px
}

@media (min-width: 768px) {
  .bsb-timeline-8 .timeline:after {
    left: 20%;
    /*left: 33%*/
  }
}

.bsb-timeline-8 .timeline > .timeline-item {
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline > .timeline-item:after {
  background: var(--bsb-tl-circle-color);
  border: var(--bsb-tl-circle-border-size) solid var(--bsb-tl-circle-border-color);
  border-radius: 50%;
  content: "";
  height: var(--bsb-tl-circle-size);
  left: calc(var(--bsb-tl-circle-offset) * -1);
  position: absolute;
  top: calc(50% - var(--bsb-tl-circle-offset));
  width: var(--bsb-tl-circle-size);
  z-index: 1
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-body {
  margin: 0;
  padding: 0;
  position: relative
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-meta {
  padding: 0 0 1rem 2rem
}

.bsb-timeline-8 .timeline > .timeline-item:first-child .timeline-meta {
  padding: 2rem 0 1rem 2rem
}

.bsb-timeline-8 .timeline > .timeline-item .timeline-content {
  padding: 0 0 2rem 2rem
}

@media (min-width: 768px) {
  .bsb-timeline-8 .timeline > .timeline-item {
    left: 20%;
    /*left: 33%;   */
    width: 67%
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-meta {
    display: flex;
    justify-content: flex-end;
    left: -100%;
    margin: 0;
    padding: 0 2rem 0 0;
    position: absolute;
    top: calc(50% - 10px);
    width: 100%;
    z-index: 1
  }

  .bsb-timeline-8 .timeline > .timeline-item:first-child .timeline-meta {
    padding: 0 2rem 0 0
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-content {
    padding: 2rem
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-indicator {
    position: relative
  }

  .bsb-timeline-8 .timeline > .timeline-item .timeline-indicator:after {
    border-width: 1px;
    border: 10px solid var(--bsb-tl-indicator-color);
    border-color: transparent var(--bsb-tl-indicator-color) transparent transparent;
    border-left-width: 0;
    content: "";
    left: calc(2rem - 10px);
    position: absolute;
    top: calc(50% - var(--bsb-tl-circle-offset));
    z-index: 1
  }
} 
        `;

    }
}